import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Philanthropy.css';

const Philanthropy = () => {
  return (
    <>
      <Helmet>
        <title>Philanthropy - Global Impact & Social Responsibility | Redbox Global</title>
        <meta
          name="description"
          content="Explore global philanthropy, social impact initiatives, humanitarian leadership, and charitable ventures shaping a better future."
        />
        <meta
          name="keywords"
          content="philanthropy, social impact, humanitarian aid, global charity, foundations, social responsibility, impact investing"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/philanthropy" />
        <meta
          property="og:title"
          content="Philanthropy - Global Impact & Social Responsibility | Redbox Global"
        />
        <meta
          property="og:description"
          content="Stories and initiatives driving meaningful change through philanthropy and social responsibility."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Philanthropy - Global Impact | Redbox Global" />
        <meta
          name="twitter:description"
          content="Explore global philanthropy and initiatives shaping a better future."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/philanthropy" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Philanthropy</h1>
          <p className="page-subtitle">
            Creating impact through purpose, generosity, and leadership
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/global-philanthropy-leaders-2026"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1200&h=600&fit=crop"
                  alt="Global philanthropy"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Cover Story</span> */}
                <h2>The World’s Most Influential Philanthropic Leaders</h2>
                <p>
                  From global foundations to grassroots movements, meet the
                  individuals and organizations redefining impact in 2026.
                </p>
                <span className="article-meta">Featured This Week</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">
            <a
              href="/article/impact-investing-future"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=600&h=400&fit=crop"
                    alt="Impact investing"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Impact</span> */}
                  <h2>The Rise of Impact Investing</h2>
                  <p>
                    How capital is being used as a force for good while delivering
                    long-term financial returns.
                  </p>
                  <span className="article-meta">February 4, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/humanitarian-crisis-response"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=600&h=400&fit=crop"
                    alt="Humanitarian aid"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Humanitarian</span> */}
                  <h2>Responding to Global Humanitarian Crises</h2>
                  <p>
                    Inside the rapid-response efforts delivering aid where it is
                    needed most.
                  </p>
                  <span className="article-meta">February 2, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/philanthropy-next-generation"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop"
                    alt="Next generation philanthropy"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Future</span> */}
                  <h2>The Next Generation of Philanthropists</h2>
                  <p>
                    How younger leaders are reshaping giving with technology,
                    transparency, and purpose.
                  </p>
                  <span className="article-meta">February 1, 2026</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Philanthropy;
